



















































import { StartActivityLogtimeWorkCommand, CompleteActivityLogtimeWorkCommand, PauseActivityLogtimeWorkCommand } from "@/server/app.commands";
import { ActivityDto, ActivityLogtimeWorkDto, LanguageDto } from "@/server/app.dtos";
import { GetLastActivityLogtimeWorkDtoQuery } from "@/server/app.queries";
import { ActivitiesService } from "@/services/api/activities.service";
import { NotificationServiceBus } from "@/services/bus/notifications.service";
import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter } from 'vuex-class';

@Component
export default class ActivityLogtimeButtonComponent extends Vue {
  @Prop() activity!: ActivityDto;
  @Getter("currentLanguage") currentLanguage!: LanguageDto;
  activitiesService: ActivitiesService = new ActivitiesService();
  isLoading: boolean = false;
  enableDialog:boolean = false;
  logTime: ActivityLogtimeWorkDto | null = null;
  isActive:boolean =false;
  seconds:number = 0;
  finalizeLogTime: any = {
    description:"",
    isBillable:false
  }
  get hasLogFile(): boolean {
    return this.logTime != null;
  }

  async created() {
    await this.loadLogtime();
    setInterval(()=>{
      if(this.isActive) {
        this.seconds++;
      }
    },1000);
  }

  async loadLogtime() {
    if (this.isLoading)
    return;
    this.isLoading = true;
    const request = new GetLastActivityLogtimeWorkDtoQuery();
    request.idActivity = this.activity.idActivity;
    await this.activitiesService
      .GetLastLogtime(request)
      .then((result: ActivityLogtimeWorkDto) => {
        this.logTime = result;
        this.isActive = this.logTime !=null ? this.logTime.isActive as boolean : false;
        this.seconds = this.logTime !=null ? this.logTime.seconds as number : 0;
      })
      .catch(() => {this.logTime = null; this.isActive = false; this.seconds=0})
      .finally(() => this.isLoading = false);
  }

  async startLogtime() {
    if (this.isLoading)
    return;
    this.isLoading = true;
    const command = new StartActivityLogtimeWorkCommand();
    command.idActivity = this.activity.idActivity;
    await this.activitiesService
      .StartLogtime(command)
      .catch((e) => {
        this.logTime = null;
        NotificationServiceBus.showErrorMessage(
          "Erro",
          e.response.data[0].message
        );
      })
      .finally(() => {this.isLoading= false; this.loadLogtime()});
  }

  async completeLogTime() {
    if (this.isLoading)
    return;
    this.isLoading = true;
    
    const command = new CompleteActivityLogtimeWorkCommand();
    command.idActivity = this.activity.idActivity;
    command.description = this.finalizeLogTime.description;
    command.isBillable = this.finalizeLogTime.isBillable;
    await this.activitiesService
      .CompleteLogtime(command)
      .then(() => {
        this.enableDialog = false;
        
        this.finalizeLogTime.description = "";
        this.finalizeLogTime.isBillable = false;
      })
      .finally(() => {this.isLoading = false; this.loadLogtime();});
  }

   async pauseLogTime() {
    if (this.isLoading)
    return;
    this.isLoading = true;
    
    const command = new PauseActivityLogtimeWorkCommand();
    command.idActivity = this.activity.idActivity;
    await this.activitiesService
      .PauseLogtime(command)
      .catch(() => (this.logTime = null))
      .finally(() => {this.isLoading= false; this.loadLogtime()});
  }

  async onClick(index:number){
    switch(index) { 
      case 0: { 
          await this.startLogtime();
          break; 
      } 
      case 1: { 
          await this.pauseLogTime(); 
          break; 
      }
      case 2: { 
          this.enableDialog = true; 
          break; 
      } 
      default: { 
          //statements; 
          break; 
      } 
    } 
  }
}
